<template>
  <div class="user-profile">
    <!-- Show a circular loader while data is being loaded -->
    <!-- @TODO - skeleton loaders -->
    <div v-if="isLoading" class="py-8 text-center">
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>

    <!-- If there's a network response -->
    <template v-else-if="userData">
      <!-- In case there's some error -->
      <div
        v-if="userData.isError"
        class="text-center font-weight-bold py-8 py-lg-12"
      >
        {{ computedErrorMessage }}
      </div>

      <!-- Otherwise, show the UI -->
      <app-view
        v-else
        :username="username"
        :platform="platform"
        :accountId="accountId"
        :user-data="userData"
        :overview-data="overviewData"
        :engagement-data="engagementData"
        :audience-data="audienceData"
        :total-values="totalValues"
      />
    </template>
  </div>
</template>

<script>
// Use a helper mixin to compute data
import loadInfluencerInsightData from "@/mixins/loadInfluencerInsightData"

// Import child component
const AppView = () => import("@/blocks/user-profile/views/AppView.vue")

// Export the SFC
export default {
  // Name of the component
  name: "UserProfile",

  // Accept incoming data from parent
  props: {
    // Since this component is used in several places, we'd be using the attributes to find the user data
    username: {
      type: String,
      required: true,
    },

    platform: {
      type: String,
      required: true
    },

    accountId: {
      type: [String, Number],
      required: false,
      default: null
    }
  },

  // Register the mixin
  mixins: [ loadInfluencerInsightData ],

  // Register the component
  components: {
    AppView
  },

  // Local data variables
  data: () => ({
    isLoading: true,

    userData: null,
    totalValues: null,
    overviewData: null,
    audienceData: null,
    engagementData: null,
    computedErrorMessage: null
  }),

  /**
   * As soon as the component data is ready
   *
   * @returns {void}
   */
  async created() {
    // Listen for isLoading event listeners
    window.addEventListener("isLoading", (e) => {
      if (
          e.detail.module === "downloadInfluencerInsight" &&
          e.detail.accountId === this.accountId &&
          e.detail.platform === this.platform
        ) {
        this.isLoading = e.detail.isLoading
      }
    })

    // When ready, fetch the user data
    const data = await this.loadProfileData(this.username, this.platform, this.accountId)

    // if some data is present
    if (data !== null) {
      // map them to be available for the template
      this.userData = data.userData
      this.totalValues = data.totalValues
      this.overviewData = data.overviewData
      this.audienceData = data.audienceData
      this.engagementData = data.engagementData
      this.computedErrorMessage = data.computedErrorMessage
    }
  }
}
</script>

<style lang="stylus">
// For all those cards in overview and other tabs
.user-profile
  .contain-height
    .v-card
      height 315px

  .download-loader
    position fixed
    z-index 101
    left 0
    top 0
    width 100%
    height 100%

    .contain-width
      width 100%
      max-width 20em

  .v-tab--active
    i.material-icons
      color #f05d56 !important
</style>
